import axios from 'axios'
import request from './common/request'

import { MERCHANT_OSS_GET_PUBLIC_DOWNLOAD_URI, MERCHANT_OSS_UPLOAD_PUBLIC_SIGNED_URI, MERCHANT_OSS_UPLOAD_PRIVATE_SIGNED_URI, MERCHANT_OSS_GET_PRIVATE_SIGNED_URI, MERCHANT_OSS_UPLOAD_PUBLIC_HOST, MERCHANT_OSS_GET_PRESIGNEDURL_URI } from './urls'

async function getUploadPublicSignedURL (suffix, contentType) {
  return request(
    {
      url: MERCHANT_OSS_UPLOAD_PUBLIC_SIGNED_URI,
      method: 'GET',
      params: {
        suffix,
        contentType
      }
    }
  )
}

async function getPublicPresignedURL (path) {
  return request(
    {
      url: MERCHANT_OSS_GET_PRESIGNEDURL_URI,
      method: 'GET',
      params: {
        path
      }
    }
  )
}

async function getUploadPrivateSignedURL (suffix, contentType) {
  return request(
    {
      url: MERCHANT_OSS_UPLOAD_PRIVATE_SIGNED_URI,
      method: 'GET',
      params: {
        suffix,
        contentType
      }
    }
  )
}

async function getPrivateSignedURL (path, contentType) {
  return request(
    {
      url: MERCHANT_OSS_GET_PRIVATE_SIGNED_URI,
      method: 'GET',
      params: {
        path,
        contentType
      }
    }
  )
}

async function getPublicDataHost () {
  return request(
    {
      url: MERCHANT_OSS_UPLOAD_PUBLIC_HOST,
      method: 'GET'
    }
  )
}

async function uploadFile (url, file) {
  return axios(
    {
      url: url,
      method: 'PUT',
      data: file,
      headers: {
        'Content-Type': file.type
      }
    }
  )
}

async function getPublicDownloadURL (params) {
  return request({
    url: MERCHANT_OSS_GET_PUBLIC_DOWNLOAD_URI,
    method: 'GET',
    params
  })
}

export default {
  getUploadPublicSignedURL,
  getPublicPresignedURL,
  getUploadPrivateSignedURL,
  getPrivateSignedURL,
  uploadFile,
  getPublicDataHost,
  getPublicDownloadURL
}



// WEBPACK FOOTER //
// ./src/api/merchant-oss-upload.js